function Service(data){
    let service = data || {};
    this.connectionType = service.connectionType;
    this.id = service.id;
}
module.exports = Service;